module.exports = __webpack_public_path__ + "media/images/flags/1x1/fro-43bbeede397c32a8d8aabfd1f1bc3292.svg";